import AttributesTab from './AttributesTab';

export default AttributesTab;
